import React, { useState, useEffect } from 'react';
import { Container, Alert } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { ApiGet } from '../../../service/ApiService';

const ProductStock = () => {
  const [products, setProducts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [error, setError] = useState(null);

  // Fetch products once (all records); adjust endpoint if needed.
  useEffect(() => {
    ApiGet(
      "/api/smartbill/stock",
      (response) => {
        setError(null);
        setProducts(response.content || []);
      },
      (err) => {
        setError(err.response?.data?.message || 'Eroare la preluarea produselor.');
        setProducts([]);
      }
    );
  }, []);

  // Fetch warehouses upfront.
  useEffect(() => {
    ApiGet(
      "/api/smartbill/warehouses",
      (response) => {
        setError(null);
        setWarehouses(response || []);
      },
      (err) => {
        setError(err.response?.data?.message || 'Eroare la preluarea depozitelor.');
        setWarehouses([]);
      }
    );
  }, []);

  // Formatter to display warehouse name based on warehouseId.
  const warehouseFormatter = (cell) => {
    const wh = warehouses.find((w) => String(w.id) === String(cell));
    return (wh && wh.warehouseName) || ("not found " + cell);
  };

  // Define table columns with filters.
  const columns = [
    {
      dataField: 'productCode',
      text: 'Cod Produs',
      filter: textFilter()
    },
    {
      dataField: 'productName',
      text: 'Nume Produs',
      filter: textFilter()
    },
    {
      dataField: 'measuringUnit',
      text: 'Unitate',
      filter: textFilter()
    },
    {
      dataField: 'quantity',
      text: 'Cantitate',
      filter: textFilter()
    },
    {
      dataField: 'warehouseId',
      text: 'Depozit',
      formatter: warehouseFormatter,
      filter: textFilter()
    }
  ];

  return (
    <Container fluid className="mt-5">
      <h1>Lista Produse</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <BootstrapTable
        keyField="id"
        data={products}
        columns={columns}
        pagination={paginationFactory()}  // Client-side pagination
        filter={filterFactory()}
        striped
        bordered
        hover
        responsive
        bootstrap4
        classes="table-sm"
      />
    </Container>
  );
};

export default ProductStock;